import {ReportService} from "./service/api/report.service";
import {ReportAgentFavoriteService} from "./service/api/report-agent-favorite.service";
import {RpLogicReportService} from "./service/api/rp-logic-report.service";
import {RpLogicReportSelectionParamService} from "./service/api/rp-logic-report-selection-param.service";
import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";
import {RpReportComponent} from "./component/protected-components/rp-report-component/rp-report.component";
import {
    RpLogicReportObjectComponent
} from "./component/protected-components/rp-logic-report/rp-logic-report-object.component";

export const RP_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['rp.Report', {route: '/rp/reports', service: ReportService, objectComponent: [{component: RpReportComponent}]}],
            ['rp.ReportField', {route: '/rp/reportFields'}],
            ['rp.ReportFilter', {route: '/rp/reportFilters'}],
            ['rp.ReportGroup', {route: '/rp/reportGroups'}],
            ['rp.ReportObject', {route: '/rp/reportObjects'}],
            ['rp.ReportObjectLink', {route: '/rp/reportObjectLinks'}],
            ['rp.ReportSorting', {route: '/rp/reportSortings'}],

            ['rp.ReportAgentFavorite', {route: '/rp/reportAgentFavorites', service: ReportAgentFavoriteService}],
            ['rp.ReportRuntime', {route: '/rp/reportRuntimes'}],
            ['rp.ReportSimpleMeta', {route: '/rp/reportSimpleMetas'}],

            ['rp.RpLogicReport', {route: '/rp/logic-reports', service: RpLogicReportService, objectComponent: [{component: RpLogicReportObjectComponent}]}],
            ['rp.RpLogicReportStep', {route: '/rp/logic-report-steps'}],
            ['rp.RpLogicReportStepMapping', {route: '/rp/logic-report-step-mappings'}],
            ['rp.RpLogicReportOutputField', {route: '/rp/logic-report-output-fields'}],
            ['rp.RpLogicReportSelectionParam', {
                route: '/rp/logic-report-selection-params',
                service: RpLogicReportSelectionParamService
            }],
        ] as EntityServiceEntry[],
        multi: true
    }
];
